import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';

import './HEventsSection.css';
import { getAllEventAction } from '../../Redux/Actions/EventActions';

const HEventsSection = () => {

    const dispatch = useDispatch()
    const isLoading = useSelector((e) => e?.LoadingReducer?.isLoading)
    const eventList = useSelector((e) => e?.EventReducer?.eventList)

    useEffect(() => {
        getDetails()
    }, [])

    const getDetails = () => {
        dispatch(getAllEventAction())
    }

    const visibleEvents = eventList.slice(0, 4);

    return (
        <section className='hevent-section'>
            <div className="container pb-5 pt-5">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-4 text-primary fw-bold border-start border-4 ps-2">EVENTS</h5>
                    <Link to="/events" className="text-decoration-none text-primary fw-semibold">View More →</Link>
                </div>

                {
                    isLoading ?
                        <div className='text-center'>
                            <Spinner animation="border" />
                        </div>
                        :
                        <div className="row g-4">
                            {
                                visibleEvents.map((event, idx) => (
                                    <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={idx}>
                                        <Link
                                            to={`events/${event?.title}`}
                                            state={event}
                                            className='text-decoration-none'
                                        >
                                            <div className="card event-card h-100">
                                                <div className="position-relative">
                                                    <img
                                                        src={`https://api.coeupdspadelhi.in/${event?.image_urls[0]}`}
                                                        className="card-img-top"
                                                        alt={event.title}
                                                        style={{ height: 230 }}
                                                    />
                                                    <div className="event-date bg-black text-white text-center position-absolute">
                                                        {/* <h5 className="mb-0">{event.eventDate}</h5> */}
                                                        <small>{event.eventDate}</small>
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <h6 className="fw-bold">{event.title}</h6>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ))
                            }
                        </div>
                }

            </div>
        </section>
    );
};

export default HEventsSection;